<template>
    <a-modal v-model="visible" width="900px" :title="$t('web.download_center' /* 下载任务中心 */)" :footer="null" centered @cancel="visible = false" class="modal-box">
        <a-table :columns="columns" :data-source="dataSource" :rowKey="record => record.id" @change="handleTableChange" :pagination="pagination" :scroll="{ x: 950 }">
            <template slot="status" slot-scope="text, record">
                <a-badge v-if="record.status == 2" color="#87d068" :text="record.status_name" />
                <p class="theme-color" v-else-if="record.status == 1">
                    <a-icon type="loading" />
                    {{ $t('web.downloading' /* 下载中 */) }}
                </p>
                <a-badge v-else color="#f50" :text="record.status_name" />
            </template>
            <template slot="file_size" slot-scope="text, record">
                <span>{{ Number(record.file_size / 1024 / 1024).toFixed(2) + 'MB' }}</span>
            </template>
            <template slot="action" slot-scope="record" v-if="record.status == 2">
                <a target="_blank" :href="record.file_url">
                    <a-button type="link">{{ $t('web.download' /* 下载 */) }}</a-button>
                </a>
            </template>
        </a-table>
    </a-modal>
</template>

<script>
// 表单字段
export default {
    name: 'DownAll',
    components: {},
    data() {
        return {
            visible: false,
            columns: [
                { title: this.$t('web.download_columns.name' /* 名称 */), dataIndex: 'down_name', width: 200 },
                { title: this.$t('web.download_columns.status' /* 文件状态 */), width: 150, align: 'center', scopedSlots: { customRender: 'status' } },
                { title: this.$t('web.download_columns.error_msg' /* 错误信息 */), dataIndex: 'error_msg', width: 120 },
                { title: this.$t('web.download_columns.time' /* 创建时间 */), dataIndex: 'time', width: 150 },
                //   { title: '生成时间', dataIndex: 'sc_time' },
                { title: this.$t('web.download_columns.file_size' /* 文件大小 */), width: 100, scopedSlots: { customRender: 'file_size' } },
                { title: this.$t('web.download_columns.action' /* 操作 */), width: 100, align: 'center', scopedSlots: { customRender: 'action' } }
            ],
            dataSource: [],
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0
            }
        };
    },
    computed: {},
    methods: {
        show() {
            this.visible = true;
            this.getDataList();
        },
        getDataList() {
            let data = {
                page: this.pagination.current,
                limit: this.pagination.pageSize
            };
            this.$request.get({ url: 'getDownList', data, costom: { hideLoading: true } }).then(res => {
                this.dataSource = res.data.data;
                this.pagination.total = res.data.totalCount;
                // 是否有未完成任务
                let isIncompletTask = this.dataSource.filter(it => it.status <= 1 && it.status != -1);
                // 如果有任务则固定s后去更新一次列表
                if (isIncompletTask.length) {
                    // 拿到第一未完成任务是否为待生成，如果时待生成则为3s否则未15s
                    let duration = isIncompletTask[0].status == 0 ? 3 : 15;
                    let timer = setTimeout(() => {
                        clearTimeout(timer);
                        this.getDataList();
                    }, duration * 1000);
                }
            });
        },
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.getDataList();
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang="less" scoped></style>
